export default "__VITE_ASSET__6834cb05__"